/* TAHA SNEAK — choix rapide de la pointure depuis les cartes produit (nécessite ts-cart.js) */
(function () {
  'use strict';
  var T = window.TSCart;
  if (!T) return;
  var d = document;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SIZE_RE = /taille|pointure|size|talla|مقاس/i;
  var BAG = '<svg class="ts-i" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 7.5h17l-1.6 12.2a1.5 1.5 0 0 1-1.5 1.3H6.6a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M8.5 11.5a3.5 3.5 0 0 0 7 0"/><path d="M8 7.5 10 3.5M16 7.5l-2-4"/></svg>';
  var quickTrigger = null;

  function qs(s, c) { return (c || d).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function esc(s) { var t = d.createElement('div'); t.textContent = s == null ? '' : String(s); return t.innerHTML; }
  function quickEl() { return d.getElementById('TsQuick'); }

  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function quickAdd(btn) {
    var handle = btn.getAttribute('data-ts-qa');
    var url = btn.getAttribute('data-url');
    T.busy(btn, true);
    getProduct(handle)
      .then(function (p) {
        T.busy(btn, false);
        var anyAvail = p.variants.some(function (v) { return v.available; });
        if (!anyAvail) { T.toast('Ce produit est épuisé.', true); return; }
        if (p.variants.length === 1) return T.add([{ id: p.variants[0].id, quantity: 1 }], btn);
        openQuick(p, btn);
      })
      .catch(function () { T.busy(btn, false); if (url) location.href = url; });
  }

  function openQuick(p, trigger) {
    var q = quickEl();
    var box = q && qs('[data-ts-quick-content]', q);
    if (!box) { location.href = p.url; return; }
    var opts = p.options || [];
    var variants = p.variants || [];
    var hasSize = opts.some(function (o) { return SIZE_RE.test(o.name); });
    var pickText = hasSize ? 'Choisissez votre pointure' : 'Choisissez une option';
    var showCmp = p.compare_at_price > p.price && !p.price_varies;

    var h = '<div class="ts-qs__prod"><span class="ts-qs__img">' +
      (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 240)) + '" alt="' + esc(p.title) + '" width="84" height="84">' : '') +
      '</span><div><p class="ts-qs__name" id="TsQuickTitle">' + esc(p.title) + '</p>' +
      '<p class="ts-qs__price"><span data-qs-price>' + (p.price_varies ? 'Dès ' : '') + esc(T.money(p.price)) + '</span>' +
      '<s data-qs-compare' + (showCmp ? '' : ' hidden') + '>' + esc(T.money(p.compare_at_price || 0)) + '</s></p></div></div>';
    opts.forEach(function (o, i) {
      h += '<fieldset class="ts-qs__opt"><legend class="ts-qs__legend">' + esc(o.name) + '</legend><div class="ts-qs__vals">';
      (o.values || []).forEach(function (v) {
        h += '<label class="ts-qs__val"><input type="radio" name="ts-qs-' + i + '" value="' + esc(v) + '" data-i="' + i + '"' +
          ((o.values || []).length === 1 ? ' checked' : '') + '><span>' + esc(v) + '</span></label>';
      });
      h += '</div></fieldset>';
    });
    h += '<button type="button" class="ts-btn ts-btn--black ts-btn--lg ts-btn--block ts-qs__add" data-qs-add disabled>' + esc(pickText) + '</button>' +
      '<a class="ts-qs__link" href="' + esc(p.url) + '">Voir la fiche produit</a>';
    box.innerHTML = h;

    var addBtn = qs('[data-qs-add]', box);
    var priceEl = qs('[data-qs-price]', box);
    var cmpEl = qs('[data-qs-compare]', box);
    var current = null;

    function sel() {
      return opts.map(function (o, i) {
        var r = qs('input[data-i="' + i + '"]:checked', box);
        return r ? r.value : null;
      });
    }
    function match(v, s) {
      var vo = v.options || [v.option1, v.option2, v.option3];
      for (var i = 0; i < s.length; i++) { if (s[i] !== null && vo[i] !== s[i]) return false; }
      return true;
    }
    function update() {
      var s = sel();
      qsa('input[data-i]', box).forEach(function (r) {
        var i = parseInt(r.getAttribute('data-i'), 10);
        var t = s.slice(); t[i] = r.value;
        var ok = variants.some(function (v) { return v.available && match(v, t); });
        r.parentNode.classList.toggle('is-na', !ok);
      });
      var complete = s.every(function (x) { return x !== null; });
      current = null;
      if (complete) {
        for (var k = 0; k < variants.length; k++) { if (match(variants[k], s)) { current = variants[k]; break; } }
      }
      if (!complete) { addBtn.disabled = true; addBtn.textContent = pickText; return; }
      if (!current) { addBtn.disabled = true; addBtn.textContent = 'Indisponible'; return; }
      priceEl.textContent = T.money(current.price);
      if (current.compare_at_price > current.price) { cmpEl.textContent = T.money(current.compare_at_price); cmpEl.hidden = false; }
      else { cmpEl.hidden = true; }
      addBtn.disabled = !current.available;
      if (current.available) addBtn.innerHTML = BAG + '<span>Ajouter au panier</span>';
      else addBtn.textContent = 'Épuisé';
    }

    box.onchange = update;
    addBtn.onclick = function () {
      if (!current || !current.available) return;
      T.add([{ id: current.id, quantity: 1 }], addBtn, function () { closeQuick(true); });
    };
    update();

    quickTrigger = trigger || null;
    T.show(q);
    T.focusSoon(qs('.ts-qs__panel', q));
  }

  function closeQuick(silent) {
    var q = quickEl();
    if (!T.isOpen(q)) return;
    T.hide(q);
    if (!silent && quickTrigger && quickTrigger.focus) T.focusSoon(quickTrigger);
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var qa = t.closest('[data-ts-qa]');
    if (qa) { e.preventDefault(); e.stopPropagation(); if (!qa.disabled) quickAdd(qa); return; }
    if (t.closest('[data-ts-quick-close]')) { e.preventDefault(); closeQuick(); }
  });

  T.closeQuick = closeQuick;
})();